/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useContext, useMemo, useState } from 'react'
import {
  Button,
  DatePicker,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  message,
} from 'antd'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { Label } from 'core/screen-util'

import { connect } from 'react-redux'
import moment from 'moment'
import MultiCauseCode from 'card-data/MultiCauseCode'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { solarEventUpdate } from 'api/pgads'
import { getTimeZone, timeZoneOption } from 'wind2/wind2utils'
import { Tabs } from 'antd/lib'
import R from 'ramda'
import TextArea from 'antd/lib/input/TextArea'
import { SOLAR_ADMIN_POWER_DATA } from '../core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { getPermitActions } from '../core/selectors'

export const saveDateformat = 'MM/DD/YYYY HH:mm'

const SolarEventDialog = ({
  targetInfo,
  visible,
  data = {},
  onHide = _ => _,
  onRetrieve,
  // isNew = false,
  causeCodeList,
  contribConditionList = [],
  selectedPlantDetails = {},
  eventTypes = [],
  actionPermits,
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const efffEventType = eventTypes.filter(f => f.eventFor === 'N')
  const { timeZone = 'EST', daylightSaving = 'Y' } = selectedPlantDetails

  const hasSolarPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: actionPermits,
        eventActions: [SOLAR_ADMIN_POWER_DATA],
        matchAny: true,
      }),
    [actionPermits]
  )

  const [insertData, setInsertData] = useState({
    ...data,
    contributingCondition: data.contributingCondition || '0',
    extension: data.extension || {
      entityId: data.entityId,
      plantId: data.plantId,
      eventId: data.eventId,
    },
  })

  const { setTmpError } = useContext(JcTmpErrorContext)
  const onSave = _ => {
    const {
      entityId,
      plantId,
      eventstart,
      eventstartTimeZone,
      causecode,
      contributingCondition,
    } = insertData
    if (!entityId) {
      message.info('Please, Select Entity.')
      return
    }
    if (!plantId) {
      message.info('Please, Select Plant.')
      return
    }
    if (!eventstart) {
      message.info('Please. Select Event Start Time.')
      return
    }
    if (!eventstartTimeZone) {
      message.info('Please ,Select Event Start Time Zone.')
      return
    }
    if (!causecode) {
      message.info('Please ,Select Cause Code.')
      return
    }
    if (!contributingCondition) {
      message.info('Please ,Select   Contributing Operating Condition Code.')
      return
    }
    setSpinning(true)
    solarEventUpdate(targetInfo)([insertData]).fork(setError, errorList => {
      setSpinning(false)
      setTmpError(errorList)
      if (!isErrorContains(errorList)) {
        message.info('Data saved.')
        onHide()
        onRetrieve()
      }
    })
  }
  const [causeCodeDialog, setCauseCodedialog] = useState({
    visible: false,
  })

  const [causeCodeExtensionDialog, setCauseCodeExtensiondialog] = useState({
    visible: false,
  })

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setInsertData({
      ...insertData,
      causecode: causeCodeValues[0] && causeCodeValues[0].causeCode,
    })
    setCauseCodedialog({
      visible: false,
      causeCodeKeyValues,
      causeCodeValues,
      causecode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : insertData.causecode,
    })
  }

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setCauseCodedialog({
      causeCodeKeyValues,
      visible: false,
    })
  }
  const openCauseCodeDialog = _ => {
    setCauseCodedialog({
      causecode: insertData.causecode,
      visible: true,
    })
  }

  const updateExtension = (key, value) => {
    setInsertData({
      ...insertData,
      extension: { ...insertData.extension, [key]: value },
    })
  }

  const onCauseCodeDialogExtensionClose = key => (
    causeCodeKeyValues,
    causeCodeValues
  ) => {
    updateExtension(key, causeCodeValues[0] && causeCodeValues[0].causeCode)
    setCauseCodeExtensiondialog({ visible: false })
  }

  const openCauseCodeExtensionaDialog = key => {
    setCauseCodeExtensiondialog({
      causeCodeValue: [insertData.extension[key]],
      causecode: insertData.extension[key],
      visible: true,
      onDialogClose: onCauseCodeDialogExtensionClose(key),
    })
  }

  const onCauseCodeTreeExtensioanCancel = causeCodeKeyValues => {
    setCauseCodeExtensiondialog({
      causeCodeKeyValues,
      visible: false,
    })
  }

  const [activeTab, setActiveTab] = useState('M')

  return (
    <Modal
      visible={visible}
      centered
      height={400}
      width={1100}
      title={<div>NERC Event Dialog</div>}
      footer={
        <div>
          <div>
            {hasSolarPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      onCancel={onHide}
    >
      <Spin spinning={spinning}>
        <Tabs activeKey={activeTab} onChange={v => setActiveTab(v)} type="card">
          <Tabs.TabPane key="M" tab="Main">
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '230px 200px 150px 200px 100px 100px',
                gap: 5,
                border: '1px solid #3e2f2f45',
                padding: 10,
              }}
            >
              {' '}
              <Label>Event Id :</Label>
              <Input disabled value={insertData.eventId} />
              <div style={{ gridColumnEnd: 'span 4' }} />
              <Label>Event Start :</Label>
              <DatePicker
                style={{}}
                value={
                  insertData.eventstart &&
                  moment(insertData.eventstart, saveDateformat)
                }
                showTime={{
                  format: 'h:mm',
                  defaultValue: moment('00:00', 'HH:mm'),
                }}
                format="MM/DD/YYYY HH:mm"
                placeholder="Select DateTime"
                onChange={date => {
                  const zone = getTimeZone({
                    pzone: timeZone,
                    daylightSavings: daylightSaving,
                    date,
                  })
                  setInsertData({
                    ...insertData,
                    eventstart: date.format(saveDateformat),
                    eventstartTimeZone: zone,
                  })
                }}
                onOk={date => {
                  const zone = getTimeZone({
                    pzone: timeZone,
                    daylightSavings: daylightSaving,
                    date,
                  })
                  setInsertData({
                    ...insertData,
                    eventstart: date.format(saveDateformat),
                    eventstartTimeZone: zone,
                  })
                }}
              />
              <Label>Start Time Zone :</Label>
              <Select
                value={insertData.eventstartTimeZone}
                onChange={eventstartTimeZone =>
                  setInsertData({ ...insertData, eventstartTimeZone })
                }
              >
                {timeZoneOption({
                  pzone: timeZone,
                  daylightSavings: daylightSaving,
                }).map(t => (
                  <Select.Option key={t.key} value={t.value}>
                    {t.text}
                  </Select.Option>
                ))}
              </Select>
              <div style={{ gridColumnEnd: 'span 2' }} />
              <Label>Event End :</Label>
              <DatePicker
                style={{ width: '100%' }}
                value={
                  insertData.eventend &&
                  moment(insertData.eventend, saveDateformat)
                }
                showTime={{
                  format: 'h:mm',
                  defaultValue: moment('00:00', 'HH:mm'),
                }}
                format="MM/DD/YYYY HH:mm"
                placeholder="Select DateTime"
                onChange={date => {
                  const zone = getTimeZone({
                    pzone: timeZone,
                    daylightSavings: daylightSaving,
                    date,
                  })
                  setInsertData({
                    ...insertData,
                    eventend: date.format(saveDateformat),
                    eventendTimeZone: zone,
                  })
                }}
                onOk={date => {
                  const zone = getTimeZone({
                    pzone: timeZone,
                    daylightSavings: daylightSaving,
                    date,
                  })
                  setInsertData({
                    ...insertData,
                    eventend: date.format(saveDateformat),
                    eventendTimeZone: zone,
                  })
                }}
              />
              <Label>End Time Zone :</Label>
              <Select
                value={insertData.eventendTimeZone}
                onChange={eventendTimeZone =>
                  setInsertData({ ...insertData, eventendTimeZone })
                }
              >
                {timeZoneOption({
                  pzone: timeZone,
                  daylightSavings: daylightSaving,
                }).map(t => (
                  <Select.Option key={t.key} value={t.value}>
                    {t.text}
                  </Select.Option>
                ))}
              </Select>
              <div style={{ gridColumnEnd: 'span 2' }} />
              <Label>Event Type :</Label>
              <Select
                value={insertData.eventtype}
                onChange={eventtype =>
                  setInsertData({ ...insertData, eventtype })
                }
              >
                {efffEventType.map(d => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.id}
                  </Select.Option>
                ))}
              </Select>
              {/* <Input
                value={insertData.eventtype}
                onChange={e =>
                  setInsertData({ ...insertData, eventtype: e.target.value })
                }
                disabled
              /> */}
              <Label>Cause Code :</Label>
              {/* <div
            style={{
              display: 'grid',
              gridTemplateColumns: '100px auto',
              gridColumnEnd: 'span 3',
              justifyItems: 'start',
            }}
          > */}
              <InputNumber
                style={{ width: '100%' }}
                value={insertData.causecode}
                onChange={causecode =>
                  setInsertData({ ...insertData, causecode })
                }
              />
              <Button
                type="primary"
                onClick={openCauseCodeDialog}
                style={{ gridColumnEnd: 'span 2', width: '100%' }}
              >
                Select Causecode
              </Button>
              {/* </div> */}
              {/* <div /> */}
              <Label>Contributing Operating Condition :</Label>
              {/* <Input
            value={insertData.contributingCondition}
            onChange={e =>
              setInsertData({
                ...insertData,
                contributingCondition: e.target.value,
              })
            }
          /> */}
              <Select
                value={insertData.contributingCondition}
                onChange={contributingCondition =>
                  setInsertData({ ...insertData, contributingCondition })
                }
                style={{ gridColumnEnd: 'span 3' }}
              >
                {contribConditionList.map(d => (
                  <Select.Option key={d.contOpCode} value={d.contOpCode}>
                    {d.contOpCode} - {d.contOpCondition}
                  </Select.Option>
                ))}
              </Select>
              <div style={{ gridColumnEnd: 'span 2' }} />
              <Label>Potential Generation Loss (MWh) : </Label>
              <InputNumber
                value={insertData.potentialLoss}
                onChange={potentialLoss =>
                  setInsertData({ ...insertData, potentialLoss })
                }
              />
              <div style={{ gridColumnEnd: 'span 4' }} />
              <Label>Event Description :</Label>
              <Input.TextArea
                css={{ gridColumnEnd: 'span 5' }}
                value={insertData.description}
                onChange={e =>
                  setInsertData({
                    ...insertData,
                    description: e.target.value,
                  })
                }
              />
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane key="E" tab="Extension">
            <div
              style={{
                height: 350,
                display: 'grid',
                gridTemplateColumns: '100px 100px 150px 50px 100px 100px 150px',
                gap: 5,
                alignItems: 'baseline',
                alignContent: 'baseline',
                border: '1px solid #3e2f2f45',
                padding: 10,
              }}
            >
              {R.range(1, 11).map(i => (
                <React.Fragment key={i}>
                  <div>Cause Code {i} :</div>
                  <InputNumber
                    value={insertData.extension['causecode' + i]}
                    onChange={val => updateExtension('causecode' + i, val)}
                  />
                  <Button
                    type="primary"
                    onClick={_ =>
                      openCauseCodeExtensionaDialog('causecode' + i)
                    }
                  >
                    Select Cause Code
                  </Button>
                  {i === 1 && <div style={{ gridRowEnd: 'span 5' }} />}
                </React.Fragment>
              ))}
              <div style={{ gridColumnEnd: 'span 7' }}>Description :</div>
              <TextArea
                style={{ gridColumnEnd: 'span 7', width: '100%' }}
                maxLength={1000}
                rows={4}
                key="description"
                value={insertData.extension.description}
                onChange={e => updateExtension('description', e.target.value)}
              />
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Spin>
      {causeCodeDialog.visible && (
        <MultiCauseCode
          key="multicausecodelist"
          // style={{ ...inlineStyle }}
          // checkable={false}
          visibleDialog={causeCodeDialog.visible}
          onDialogClose={onCauseCodeDialogClose}
          onCancelAction={onCauseCodeTreeCancel}
          defaultExpandedKeys={
            insertData.causecode ? causeCodeDialog.selectedKeys : []
          }
          selectedKeys={causeCodeDialog.causeCodeKeyValues}
          selectedValues={causeCodeDialog.causeCodeValues}
          unitCodes={[]}
          multiple={false}
          checkable={false}
          selectable
          causeCodeList={causeCodeList}
          {...causeCodeDialog}
        />
      )}

      {causeCodeExtensionDialog.visible && (
        <MultiCauseCode
          key="multicausecodelist"
          // style={{ ...inlineStyle }}
          // checkable={false}
          visibleDialog={causeCodeExtensionDialog.visible}
          onCancelAction={onCauseCodeTreeExtensioanCancel}
          defaultExpandedKeys={
            insertData.causecode ? causeCodeExtensionDialog.selectedKeys : []
          }
          selectedKeys={causeCodeExtensionDialog.causeCodeKeyValues}
          selectedValues={causeCodeExtensionDialog.causeCodeValues}
          unitCodes={[]}
          multiple={false}
          checkable={false}
          selectable
          causeCodeList={causeCodeList}
          {...causeCodeExtensionDialog}
        />
      )}
    </Modal>
  )
}

const mapStateToProps = state => ({
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(SolarEventDialog)
